<template>
  <div class="multi-color-fission">
    <div class="mcf-toolbar">
      <button class="scg-back-btn" @click="goBack">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16">
          <polyline points="15 18 9 12 15 6"/>
        </svg>
        返回宣传图生成
      </button>
      <span class="scg-mode-tag">多色裂变</span>
      <button class="scg-generate-all-btn" @click="generateAllFission">
        全部裂变
      </button>
      <button
        class="scg-fission-all-btn"
        @click="goToMainImage"
      >进入主图生成</button>
    </div>

    <div v-for="(product, pi) in activeProducts" :key="product.id" class="mcf-product-section">
      <div class="mcf-product-header">
        <span class="mcf-product-name">{{ product.name }}</span>

        <div class="mcf-source-thumbs">
          <span class="mcf-source-label">宣传图:</span>
          <div v-for="sel in getSelectedSlots(pi)" :key="`${sel.pi}-${sel.si}`" class="mcf-source-thumb"
            :class="{ selected: workbench.isPromoSelectedForMain(sel.pi, sel.si) }"
            @click="workbench.togglePromoForMain(sel.pi, sel.si)"
          >
            <img v-if="workbench.imageGen.genResults[sel.pi]?.[sel.si]?.url"
              :src="workbench.imageGen.genResults[sel.pi][sel.si].url" />
            <div class="mcf-thumb-check">
              <svg v-if="workbench.isPromoSelectedForMain(sel.pi, sel.si)" viewBox="0 0 24 24" fill="#165dff" width="14" height="14">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
              </svg>
              <svg v-else viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" width="14" height="14">
                <rect x="3" y="3" width="18" height="18" rx="3"/>
              </svg>
            </div>
          </div>
        </div>

        <button class="mcf-add-color" @click="workbench.addFissionColor(pi)">+ 添加颜色</button>
      </div>

      <div v-for="(color, ci) in (workbench.imageGen.fissionColors[pi] || [])" :key="color.id" class="mcf-color-block">
        <FissionColorRow
          :productIndex="pi"
          :colorIndex="ci"
          :color="color"
          :canRemove="(workbench.imageGen.fissionColors[pi] || []).length > 1"
          @remove="workbench.removeFissionColor(pi, ci)"
        />
        <div class="mcf-color-gen-row">
          <button class="mcf-gen-color-btn" @click="workbench.generateAllFissionForColor(pi, ci)">
            生成此颜色裂变
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useWorkbenchStore } from '@/stores/useWorkbenchStore'
import FissionColorRow from './FissionColorRow.vue'

const workbench = useWorkbenchStore()

const activeProducts = computed(() => {
  const indices = [...new Set(workbench.selectedFissionSlots.map(s => s.pi))]
  return indices.map(i => workbench.products[i]).filter(Boolean)
})

const getSelectedSlots = (pi) => {
  return workbench.selectedFissionSlots.filter(s => s.pi === pi)
}

const generateAllFission = () => {
  const indices = [...new Set(workbench.selectedFissionSlots.map(s => s.pi))]
  for (const pi of indices) {
    workbench.generateAllFissionForProduct(pi)
  }
}

const goToMainImage = () => {
  workbench.enterMainImageGen()
}

const goBack = () => {
  workbench.imageGen.step = 2
}
</script>
